<!-- ServicesHeader.vue -->

<template>

<div v-if="!isFetching('fetchingServices')">
  <div class="d-flex mb-3 border-bottom align-items-end">
    <div class="col-4 d-flex align-items-end">
      <div class="p-2 ps-0">
        <div class="fs-3 mb-0 fw-semibold">Services</div>
      </div>
    </div>

    <div class="col-2 text-end ms-auto">
      <div class="p-2">
        <button type="button" class="btn btn-sm btn-primary" @click="openCreateServiceModal"><i class="bi bi-plus-lg"></i> Add Service</button>
      </div>
    </div>
  </div>
</div>

  <!-- Create Service -->
  <CreateServiceModal ref="createServiceModal" @showAlert="showAlert" @showError="showError" />

</template>

<script>
import { mapGetters } from 'vuex';
import CreateServiceModal from '@/components/CreateServiceModal.vue';

export default {
  name: 'ServicesHeader',
  emits: [
    'showAlert',
    'showError',
  ],
  props: {
  },
  components: {
    CreateServiceModal,
  },

  data() {
    return { };
  },

  computed: {
    ...mapGetters([
      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',

      'getProperty',
    ]),
  },

  watch: { },

  methods: {
    showAlert(type, message) {
      this.$emit('showAlert', type, message);
    },

    showError(errorMessage) {
      this.$emit('showError', errorMessage);
    },

    async openCreateServiceModal() {
      this.$refs.createServiceModal.openModal();
    },
  },

  created() { },
};
</script>